import { createContext, useContext, type ReactNode } from 'react';
import type { ResolvedProductAuthBranding } from '@/modules/auth/hooks/useProductAuthBranding';

const ProductAuthBrandingContext = createContext<ResolvedProductAuthBranding | null>(null);

export function ProductAuthBrandingProvider({
  value,
  children,
}: {
  value: ResolvedProductAuthBranding | null;
  children: ReactNode;
}) {
  return (
    <ProductAuthBrandingContext.Provider value={value}>
      {children}
    </ProductAuthBrandingContext.Provider>
  );
}

export function useProductAuthBrandingContext(): ResolvedProductAuthBranding | null {
  return useContext(ProductAuthBrandingContext);
}
